import { render, staticRenderFns } from "./PatientStatusChip-comp.vue?vue&type=template&id=50818002&scoped=true&"
import script from "./PatientStatusChip-comp.vue?vue&type=script&lang=js&"
export * from "./PatientStatusChip-comp.vue?vue&type=script&lang=js&"
import style0 from "./PatientStatusChip-comp.vue?vue&type=style&index=0&id=50818002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50818002",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VTooltip})
